
export default function UserDataFactory($http, appSettings) {

    'ngInject';

    var userDataFactory = {};
    var baseUrl = appSettings.IcebergApiUserInfoEndpoint + '/users';

    userDataFactory.getUserInfo = function () {
        return $http.get(baseUrl + '/me');
    };
    userDataFactory.getUserClaims = function () {
        return $http.get(baseUrl + '/me/claims');
    };
    userDataFactory.updateUserClaims = function (claims) {
        return $http.put(baseUrl + '/me/claims', claims);
    };

    userDataFactory.changeEmail = function (newemail) {
        return $http.post(baseUrl + '/me/email', newemail);
    };

    userDataFactory.updateUserInfo = function (id, firstName, lastName) {

        if (!id) {
            return id;
        }
        var userId = id;
        var userInfo = [{
            "op": "update",
            "claims": {
                "firstName": firstName || "",
                "lastName": lastName || "",
                // IANA JWT claims.
                "given_name": firstName || "",
                "family_name": lastName || ""
            }
        }];
        return $http.patch(baseUrl + '/' + userId + '/claims', userInfo);
    };

    userDataFactory.postUserInfo = function (id, firstName, lastName) {

        if (!id) {
            return id;
        }
        var userId = id;
        var userInfo = [{
            "op": "add",
            "claims": {
                "firstName": firstName || "",
                "lastName": lastName || "",
                // IANA JWT claims.
                "given_name": firstName || "",
                "family_name": lastName || ""
            }
        }];
        return $http.patch(baseUrl + '/' + userId + '/claims', userInfo);
    };

    userDataFactory.postUserRole = function (userRole) {
        return $http.post(appSettings.IcebergApiUserInfoEndpoint + '/roles', userRole);
    };

    userDataFactory.changePassword = function (model) {
        return $http.post(baseUrl + '/me/password', model);
    };

    return userDataFactory;
}
